import request from '../utils/request';
import qs from "qs";

//国美查询列表
export const GmPhoneInfo = serNum => {
	return request.get('/api/gome/queryCustBySerNum?serNum=' + serNum)
};

//国美单个充值预存款
export const prepayAdd = param => {
	return request.post('/api/gome/recharge', qs.stringify(param))
};
//国美充值列表
export const rechargeRecord = param => {
	return request.post('/api/gome/rechargeRecord', qs.stringify(param))
};
//国美返销可批量
export const cancelRecharge = param => {
	return request.post('/api/gome/cancelRecharge', qs.stringify(param))
};
//国美批量查询
export const batchQuery = param => {
	return request.post('/api/gome/batchQuery', qs.stringify(param))
};
//国美用户信息批量查询
export const batchQueryRecord = param => {
	return request.post('/api/gome/batchQueryRecord', qs.stringify(param))
};

//国美资金池添加金额
export const fundPoolAdd = param => {
	return request.post('/api/gome/fundPoolAdd', qs.stringify(param))
};
//国美资金池记录
export const fundPool = param => {
	return request.post('/api/gome/fundPool', qs.stringify(param))
};
//国美批量充值
export const batchTopUp = param => {
	return request.post('/api/gome/batchTopUp', qs.stringify(param))
};
//国美批量充值列表
export const batchTopUpRecord = param => {
	return request.post('/api/gome/batchTopUpRecord', qs.stringify(param))
};
//国美批量充值下载
export const downloadBatchTopUp = param => {
	return request.post('/api/gome/downloadBatchTopUp', qs.stringify(param), {
		responseType: 'blob'
	})
};
//国美停机
export const stopPhone = param => {
	return request.post('/api/gome/stopPhone', qs.stringify(param))
};
//国美停复机记录
export const stopRecord = param => {
	return request.post('/api/gome/stopRecord', qs.stringify(param))
};
//国美话单异常列表
export const gmErrRecord = param => {
	return request.post('/api/gome/errRecord', qs.stringify(param))
};












//国美呼叫限频列表
export const deptParam = param => {
	return request.get('/api/Snail/deptParam?phoneNumber=' + param.phoneNumber + '&&userId=' + param.userId +
		'&&pageIndex=' + param.pageIndex + '&&pageSize=' + param.pageSize)
};
//国美呼叫限频次数设置
export const AddFrequencyLimit = param => {
	return request.post('/api/Snail/AddFrequencyLimit', qs.stringify(param))
};
//国美预存款列表
export const findPageByOperNo = param => {
	return request.post('/api/Snail/findPageByOperNo', qs.stringify(param))
};
//国美查询预存款
export const prepayQuery = param => {
	return request.post('/api/Snail/prepayQuery', qs.stringify(param))
};

//国美批量充值预存款
export const prepayAddbatch = param => {
	return request.post('/api/Snail/prepayAddbatch', qs.stringify(param))
};
//国美预存款退款
export const prepayRecoil = param => {
	return request.post('/api/Snail/prepayRecoil', qs.stringify(param))
};
//国美呼叫限频删除
export const deleteBatch = param => {
	return request.post('/api/Snail/deleteBatch', qs.stringify(param))
};